export const modalContent = {
    maxHeight: 'calc(90vh - 140px)',
    overflowY: 'auto',
}

export const modalHeader = {
    alignItems: 'center',
    background: '$modalHeaderBackground',
    borderBottom: '1px solid $modalBorder',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    display: 'flex',
    gap: '10px',
    padding: '$modalPaddingVertical $modalPaddingHorizontal',
}
